export default __webpack_public_path__ + "static/media/breakfast5.c51697f2.png";